import {
  FmsTextVariable,
  TextLanguage,
  TranslatedText,
} from "Store/texts/interfaces";

import React from "react";

interface Props {
  paragraph: TranslatedText;
  lang: TextLanguage;
  phoneNumber: TranslatedText;
}

export const Description = ({
  paragraph,
  lang,
  phoneNumber,
}: Props): React.ReactElement => {
  const containsPhoneNumber = paragraph[lang].includes(
    FmsTextVariable.PHONE_NUMBER,
  );
  const multiPartTexts =
    containsPhoneNumber && paragraph[lang].split(FmsTextVariable.PHONE_NUMBER);

  if (multiPartTexts) {
    return (
      <p>
        {multiPartTexts.map((textPart, index) => (
          <React.Fragment key={textPart}>
            {textPart}
            {index < multiPartTexts.length - 1 && (
              <a href={`tel:${phoneNumber[lang]}`}>{phoneNumber[lang]}</a>
            )}
          </React.Fragment>
        ))}
      </p>
    );
  }

  return <p>{paragraph[lang]}</p>;
};
